import { Connector } from '@api/api/alfred-integrations';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteByoConnector,
  getConnectors,
} from '@terminal/services/alfred-intergations/alfred-integrations-service';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { AppCardService } from '@terminal/views/alfred/research/connection-apps-panel/AppCard';

export const QUERY_KEY_BYO_MCP_CONNECTORS = 'QUERY_KEY_BYO_MCP_CONNECTORS';

export const toAppCardServices = (connectors: Connector[]): AppCardService[] =>
  connectors
    .filter(connector => connector.kind === 'custom')
    .flatMap(connector => {
      if (connector.services?.length) {
        return connector.services.map(service => ({
          type: service.serviceId,
          providerId: connector.providerId,
          serviceId: service.serviceId,
          connected: service.status === 'connected',
          name: connector.name,
          authType: connector.authType,
        }));
      }

      return [
        {
          type: connector.providerId,
          providerId: connector.providerId,
          connected: connector.status === 'connected',
          name: connector.name,
          authType: connector.authType,
        },
      ];
    });

export const useByoMcpConnectors = (userId?: string) => {
  const isByoEnabled = useFlags(state =>
    state.getFeatureFlagState('REASON-2519-BYO')
  );

  return useQuery({
    queryKey: [QUERY_KEY_BYO_MCP_CONNECTORS, userId],
    enabled: isByoEnabled && !!userId,
    queryFn: getConnectors,
    select: data => toAppCardServices(data.data?.connectors ?? []),
  });
};

export const useDeleteByoConnector = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (connectorId: string) => {
      const response = await deleteByoConnector(connectorId);
      if (response.error) {
        throw response.error;
      }
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_BYO_MCP_CONNECTORS],
      });
    },
  });
};
